import ls from 'local-storage'

import React, { useState, useEffect, useContext } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

// Data
import { getVisitor, init, registerUser, logEvent } from './store/alpha'
import { login, getUser, authenticateWithToken, fetchContactInfo, setActiveCompany } from './store/alpha'
import { getBusinessInfo, fetchBusinessInfo } from './store/alpha'

const styles = theme => ({
  root: {
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
})

const AppBase = (props) => {
  const { classes, business, history, user, connectionState, params } = props
  const { fetchBusinessInfo, login, authenticateWithToken, visitor, init, registerUser, fetchContactInfo } = props
  
  const getWSHost = () => {
    let host = process.env.REACT_APP_GOAPP_API_URL + "/ws/conversation/"      
    host = host.replace("http://", "ws://")
    host = host.replace("https://", "wss://")
    host += "?"
    if (user.isLoggedIn)
      host += "&token=" + user.authToken
    host += "&service_key=" + business.data.uid
    return host
  }  
  
  useEffect(() => {  
    if (params.get('reset') == 1) {
      ls.remove('_goid')
      ls.remove('_userInfo')
      // Reload app
      window.open(process.env.REACT_APP_PUBLIC_URL, "_self")
      return
    }

    let authToken = params.get('auth_token')

    if (!business.lastFetched) {
      if (!business.isFetching)
        fetchBusinessInfo()
    }
    else if (user.isAuthenticating || user.authError) {
      // Wait.
    }
    // Check token from callback URL
    else if (authToken && !user.isLoggedIn) {
      let authSuccess = params.get('auth_success')
      authenticateWithToken(authToken)
      
      params.delete('auth_token')
      params.delete('auth_success')
      
      // Update url
      // Note: Should use history.replace so that path with token not pushed
      // to history, but it doesn't work.
      history.push({ pathname: history.location.pathname, search: params.toString()})
    }
    else if (user.isAuthenticating) {
      // Just wait
    }
    else if (user.userInfo && !user.isLoggedIn) {
      if (!user.isAuthenticating)
        // Try to login automatically
        login()
    }
    else if (!visitor.isInitialized) {
      init()
    }
    else if (!visitor.isRegistered) {
      let registerData = {}
      if (user.isLoggedIn)
        registerData = {
          external_app: 'alpha.apps.directory',
          external_model: 'user',
          external_id: user.userInfo.uid,
          first_name: user.userInfo.first_name,
          last_name: user.userInfo.last_name,
          email: user.userInfo.email,
          mobile_no: user.userInfo.mobile_no
        }      
      else 
        registerData =  {
        }
        
      registerUser(registerData)
    }
    else if (user.isUpdatingContact) {
      // Just wait
    }
    else if (!user.lastContactUpdate) {
      // Fetch contact info.
      fetchContactInfo()
    }
  })
  
  if (business.lastFetched && !user.isAuthenticating && visitor.isRegistered && user.lastContactUpdate ) {
    
    const { mainComponent, mainProps } = props
    
    let component = React.createElement(mainComponent, {
      ...mainProps,
      user,
      business,
      visitor,
      })
  
    return (  
      <div className={classes.root}>
        { component }
      </div>
    )
  }
  else {
    // Show loading messages
    
    let message = "..."
    if (business.isFetching)
      message = "Initializing..."
    else if (user.userInfo && !user.isLoggedIn)
      message = "Logging in..."
    else if (user.isAuthenticating)
      message = "Authenticating..."
    else if (visitor.isInitializing || visitor.isRegistering)
      message = "Almost done..."
    else if (user.isUpdatingContact)
      message = "One second..."
    else {      
    }
    
    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
        { message }
        </div>
      </div>
    )
  }  
}

const mapStateToProps = (state, ownProps) => {
  let urlParams = new URLSearchParams(ownProps.location.search)
  
  return {
    user: getUser(state),
    business: getBusinessInfo(state, '0'),
    visitor: getVisitor(state),
    params: urlParams,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
//  let callbackUrl = process.env.REACT_APP_PUBLIC_URL + ownProps.location.path
  let callbackUrl = window.location.href
//  alert(callbackUrl)
  
  return {
    fetchBusinessInfo: () => {
      dispatch(fetchBusinessInfo('0'))
    },
    login: () => {
      dispatch(login(callbackUrl, true))
    },
    authenticateWithToken: (authToken) => {
      dispatch(authenticateWithToken(authToken))
    },
    init: () => {
      dispatch(init())
    },
    registerUser: (registerData) => {
      dispatch(registerUser(registerData))
    },
    fetchContactInfo: () => {
      dispatch(fetchContactInfo())
    },
    setActiveCompany: (companyID) => {
      dispatch(setActiveCompany(companyID))
    },
    
  }
}

const App = withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AppBase)
  )
)

export const withAppBase = (component, params={}) => (props) => {
  return (
    <App
      mainComponent={component}
      mainProps={props}
      {...params}
      />
  )
}

export default App